import { render, staticRenderFns } from "./BulkImportResults.vue?vue&type=template&id=68f8f0a3"
import script from "./BulkImportResults.vue?vue&type=script&lang=ts"
export * from "./BulkImportResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports